import { Injectable } from '@angular/core';
import { VerificationRequestData } from '../../../models/verification-request-data';
import { VerificationResponseData } from '../../../models/verification-response-data';

@Injectable()
export class VerificationSession {
  verificationRequestData: VerificationRequestData = new VerificationRequestData();
  verificationResponseData: VerificationResponseData;
}
